import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { BrnDialog } from '@spartan-ng/brain/dialog';

/**
 * Helm dialog component (spartan layer).
 * Wraps BrnDialog as a host directive and provides the `hlm-dialog` selector.
 * Use together with `*hlmDialogPortal` on the content template.
 *
 * @example
 * <hlm-dialog>
 *   <button hlmDialogTrigger>Open</button>
 *   <hlm-dialog-content *hlmDialogPortal>...</hlm-dialog-content>
 * </hlm-dialog>
 */
@Component({
  selector: 'hlm-dialog',
  standalone: true,
  hostDirectives: [
    {
      directive: BrnDialog,
      inputs: [
        'state',
        'closeOnOutsidePointerEvents',
        'closeOnBackdropClick',
        'disableClose',
        'aria-label',
        'aria-labelledby',
        'aria-describedby',
        'role',
      ],
      outputs: ['closed', 'stateChanged'],
    },
  ],
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HlmDialogComponent {}
